export const SCHOOLS_SUCCESS = 'SCHOOLS_SUCCESS';
export const SCHOOLS_FAILURE = 'SCHOOLS_FAILURE';


export const schoolsSuccess = data => ({
  type: SCHOOLS_SUCCESS,
  payload: data,
});

export const schoolsFailure = errString => ({
  type: SCHOOLS_FAILURE,
  payload: { err: errString },
});
